<aside class="brand">
  <img class="brand__logo" src="assets/images/logo-ats.png" alt="ATS Informática">

  <div class="brand__hero">
    <img class="brand__ilustracao" src="assets/images/auth-ilustracao.svg" alt="">
    <div class="brand__texto">
      <h2 class="brand__titulo">A gestão da sua empresa,<br><span>sem complicação.</span></h2>
      <p class="brand__subtitulo">Tudo o que o seu negócio precisa, em um só lugar</p>
    </div>
  </div>

  <div class="brand__rodape">
    <span>© ATS Informática</span>
    <a href="#">Termos de uso</a>
    <a href="#">Privacidade</a>
  </div>
</aside>
